import { render, staticRenderFns } from "./EmployeeLeaveSummary.vue?vue&type=template&id=4ec5adf9&scoped=true&"
import script from "./EmployeeLeaveSummary.vue?vue&type=script&setup=true&lang=js&"
export * from "./EmployeeLeaveSummary.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec5adf9",
  null
  
)

export default component.exports